import auth_config from '../auth_config.json';

export const environment = {
  production: false,
  // apiUrl: '/api/mp',
  apiUrl: 'https://test.api.anymatch.de/api/mp',
  auth: {
    domain: auth_config.domain,
    clientId: auth_config.clientId,
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: auth_config.audience,
      scope: 'openid profile email offline_access',
    },
  },
  SOCKET_ENDPOINT: 'https://test.api.anymatch.de/mp/sessions',
  mapbox: {
    apiKey:
      'pk.eyJ1IjoidmF2ZS1kZXYiLCJhIjoiY2t1OWczcGJqMDZrdTJwcXY4NXF5MnYxNiJ9.Efn0pOFJPgDNqn4l9XesIw',
  },
};
